// Store Amplitude event names in an enum
enum AmplitudeEventNames {
    ACTION_ITEMS_SHOWN = "action_items_shown",
    CALENDAR_COACH_CTA_CLICK = "calendar_coach_cta_click",
    CALENDAR_INTEGRATION_CARD_SHOWN = "calendar_integration_card_shown",
    CALENDAR_INTEGRATION_DISMISSED = "calendar_integration_dismissed",
    CALENDAR_IMPORT_BUTTON_CLICKED = "calendar_import_button_clicked",
    CALENDAR_INTEGRATION_STARTED = "calendar_integration_started",
    CALENDAR_SECTION_SHOWN = "calendar_section_shown",
    CHAT_INPUT_SHOWN = "chat_input_shown",
    CHAT_USE_CASE_ENTRANCES_SHOWN = "chat_use_case_entrances_shown",
    CHAT_USE_CASE_ENTRANCE_CLICKED = "chat_use_case_entrance_clicked",
    CLIENT_ANALYTICS_CONVERSATION_THEME_SHOWN = "client_analytics_conversation_theme_shown",
    CLIENT_ANALYTICS_DATE_FILTERS_SELECTED = "client_analytics_date_filters_selected",
    CLIENT_ANALYTICS_FILTERS_CLEARED = "client_analytics_filters_cleared",
    CLIENT_ANALYTICS_IMPACT_SUBTAB_SHOWN = "client_analytics_impact_subtab_shown",
    CLIENT_ANALYTICS_INSIGHTS_SUBTAB_SHOWN = "client_analytics_insights_subtab_shown",
    CLIENT_ANALYTICS_K_ANONYMIZATION_WARNING_SHOWN = "client_analytics_k_anonymization_warning_shown",
    CLIENT_ANALYTICS_SSO_FILTERS_SELECTED = "client_analytics_sso_filters_selected",
    CLIENT_ANALYTICS_TAB_SHOWN = "client_analytics_tab_shown",
    CONVERSATION_SEARCH_SUBMITTED = "conversation_search_submitted",
    CONVERSATION_SEARCH_RESULT_CLICKED = "conversation_search_result_clicked",
    CONNECTION_ADD = "connection_add",
    CONNECTION_ADD_BUTTON_CLICKED = "connection_add_button_clicked",
    CONNECTION_CARD_VIEWED = "connection_card_viewed",
    CONNECTION_COLLABORATION_PROFILE_CLICKED = "connection_collaboration_profile_clicked",
    CONNECTION_DETAIL_CLICKED = "connection_detail_clicked",
    CONNECTION_DISAMBIGUATED = "connection_disambiguated",
    CONNECTION_DISMISSED = "connection_dismissed",
    CONNECTION_UPDATE = "connection_update",
    CONNECTION_SUGGESTION_CLICKED = "connection_suggestion_clicked",
    CONNECTION_DELETE_NOTE_BUTTON_CLICKED = "connection_delete_note_button_clicked",
    CONNECTION_NOTE_DELETED = "connection_note_deleted",
    CONNECTION_EDIT_NOTE_BUTTON_CLICKED = "connection_edit_note_button_clicked",
    CONNECTION_EDIT_BUTTON_CLICKED = "connection_edit_button_clicked",
    CONNECTION_DELETE = "connection_delete",
    COLLABORATION_PROFILE_CARD_SHOWN = "collaboration_profile_card_shown",
    COLLABORATION_PROFILE_CARD_CLICKED = "collaboration_profile_card_clicked",
    CONNECTION_VIEW_PERSON_CLICKED = "connection_view_profile_clicked",
    CONNECTION_UNLINK_PUBLIC_PROFILE = "connection_unlink_public_profile",
    CONNECTION_ADD_CONTEXT_BUTTON_CLICKED = "connection_add_context_button_clicked",
    CONNECTION_LINK_PROFILE_BUTTON_CLICKED = "connection_link_profile_button_clicked",
    CONNECTION_LINK_PUBLIC_PROFILE = "connection_link_public_profile",
    CONNECTION_INVITE_COPIED = "connection_invite_copied",
    CONNECTION_LINK_SEARCH_CANCELED = "connection_link_search_canceled",
    CONNECTION_WRONG_CONNECTION_CLICKED = "connection_wrong_connection_clicked",
    CONNECTIONS_EMPTY_STATE_CTA_CLICKED = "connections_empty_state_cta_clicked",
    CONNECTIONS_HELP_LINK_CLICKED = "connections_help_link_clicked",
    CSV_IMPORT_CANCELLED = "csv_import_cancelled",
    CSV_IMPORT_DIALOG_OPENED = "csv_import_dialog_opened",
    CSV_IMPORT_FAILED = "csv_import_failed",
    CSV_IMPORT_FILE_SELECTED = "csv_import_file_selected",
    CSV_IMPORT_PREVIEW_SHOWN = "csv_import_preview_shown",
    CSV_IMPORT_SUBMITTED = "csv_import_submitted",
    CSV_IMPORT_SUCCESS = "csv_import_success",
    CSV_IMPORT_TEMPLATE_DOWNLOADED = "csv_import_template_downloaded",
    COMPETENCY_ASSESSMENT_VIEWED = "competency_assessment_viewed",
    COMPETENCY_ASSESSMENT_STARTED = "competency_assessment_started",
    COMPETENCY_ASSESSMENT_SUBMITTED = "competency_assessment_submitted",
    COMPETENCY_ASSESSMENT_RETAKE = "competency_assessment_retake",
    SCHNEIDER_ASSESSMENT_VIEWED = "schneider_assessment_viewed",
    SCHNEIDER_ASSESSMENT_STARTED = "schneider_assessment_started",
    SCHNEIDER_ASSESSMENT_SUBMITTED = "schneider_assessment_submitted",
    SCHNEIDER_ASSESSMENT_RETAKE = "schneider_assessment_retake",
    CONNECT_MS_TEAMS_CARD_SHOWN = "connect_ms_teams_card_shown",
    CONNECT_MS_TEAMS_HOMEPAGE_CARD_CLICKED = "connect_ms_teams_homepage_card_clicked",
    COACH_DICTATION_PREVENTED = "coach_dictation_prevented",
    COACH_DICTATION_SKIPPED = "coach_dictation_skipped",
    COACH_DICTATION_SPEED_CHANGED = "coach_dictation_speed_changed",
    COACH_DICTATION_START = "coach_dictation_start",
    COACH_DICTATION_STOP = "coach_dictation_stop",
    GOAL_ARCHIVED = "goal_archived",
    GOAL_CHAT_STARTED = "goal_chat_started",
    GOAL_COMPLETED = "goal_completed",
    GOAL_CREATED = "goal_created",
    GOAL_EXPANDED = "goal_expanded",
    GOAL_FORM_OPENED = "goal_form_opened",
    GOAL_PRIORITIZED = "goal_prioritized",
    GOAL_UPDATED = "goal_updated",
    GOALS_COMPLETED_SECTION_TOGGLED = "goals_completed_section_toggled",
    GOALS_PAGE_VIEWED = "goals_page_viewed",
    DEVELOPMENT_JOURNEYS_GOAL_CARD_VIEWED = "development_journeys_goal_card_viewed",
    DEVELOPMENT_JOURNEYS_GOAL_CARD_ACTION = "development_journeys_goal_card_action",
    DEVELOPMENT_JOURNEYS_PRIMARY_ACTION_CLICKED = "development_journeys_primary_action_clicked",
    DEVELOPMENT_JOURNEYS_WEEK_VIEWED = "development_journeys_week_viewed",
    DEVELOPMENT_JOURNEYS_WEEKLY_WORKFLOW_VIEWED = "development_journeys_weekly_workflow_viewed",
    FEEDBACK_GATHERING = "feedback_gathering",
    FEEDBACK_HOMEPAGE_CARD_SHOWN = "feedback_homepage_card_shown",
    FEEDBACK_ISSUES_FORM_DISMISSED = "feedback_issues_form_dismissed",
    FEEDBACK_ISSUES_FORM_SAVED = "feedback_issues_form_saved",
    FEEDBACK_ISSUES_FORM_SHOWN = "feedback_issues_form_shown",
    FEEDBACK_MODAL_OPENED = "feedback_modal_opened",
    FOLLOWUP_SCHEDULED = "followup_scheduled",
    GUIDED_SETUP_HOMEPAGE_CARD_SHOWN = "guided_setup_homepage_card_shown",
    GUIDED_SETUP_HOMEPAGE_CARD_CLICKED = "guided_setup_homepage_card_clicked",
    HOMEPAGE_CALENDAR_INSIGHT_SHOWN = "homepage_calendar_insight_shown",
    HOMEPAGE_CALENDAR_INSIGHT_DIVE_DEEPER_CLICKED = "homepage_calendar_insight_dive_deeper_clicked",
    HOMEPAGE_CARD_CLICKED = "homepage_card_clicked",
    HOMEPAGE_TAB_CLICKED = "homepage_tab_clicked",
    HOMEPAGE_CARD_SHOWN = "homepage_card_shown",
    HOMEPAGE_CHAT_STARTED = "homepage_chat_started",
    HOMEPAGE_SCHEDULE_BUTTON_CLICKED = "homepage_schedule_button_clicked",
    HOMEPAGE_WRAPPED_ACTION_ITEM_CLICKED = "homepage_wrapped_action_item_clicked",
    HOMEPAGE_WRAPPED_CARD_CLICKED = "homepage_wrapped_card_clicked",
    HOMEPAGE_WRAPPED_CTA_SHOWN = "homepage_wrapped_cta_shown",
    HOMEPAGE_WRAPPED_REVIEWED_CARD_CLICKED = "homepage_wrapped_reviewed_card_clicked",
    INSIGHT_DIVE_DEEPER_CLICKED = "INSIGHT_DIVE_DEEPER_CLICKED",
    MANAGER_CARD_SHOWN = "manager_card_shown",
    MANAGER_CARD_SUBMITTED = "manager_card_submitted",
    MANAGER_SELECTOR_CONFIRMED = "manager_selector_confirmed",
    MAIN_MENU_ITEM_CLICKED = "main_menu_item_clicked",
    MEET_NADIA_CARD_SHOWN = "meet_nadia_card_shown",
    MEET_NADIA_CLICKED = "meet_nadia_clicked",
    // Named apart from the server-side `page_view` series so that series stays clean;
    // this one exists only so Guides and Surveys have a client-observed event to
    // trigger on.
    MOBILE_CLIENTSIDE_PAGE_VIEWED = "mobile_clientside_page_viewed",
    MOBILE_APP_BANNER_DOWNLOAD_CLICKED = "mobile_app_banner_download_clicked",
    MOBILE_APP_BANNER_DISMISSED = "mobile_app_banner_dismissed",
    MYWORK_HOMEPAGE_CARD_SHOWN = "mywork_homepage_card_shown",
    MYWORK_HOMEPAGE_CARD_CLICKED = "mywork_homepage_card_clicked",
    MYWORK_HOMEPAGE_CAROUSEL_SHOWN = "mywork_homepage_carousel_shown",
    MYWORK_HOMEPAGE_CAROUSEL_NAVIGATED = "mywork_homepage_carousel_navigated",
    MYWORK_HOMEPAGE_CAROUSEL_SEE_ALL_CLICKED = "mywork_homepage_carousel_see_all_clicked",
    MYWORK_HOMEPAGE_CAROUSEL_DISMISSED = "mywork_homepage_carousel_dismissed",
    MYWORK_INSIGHT_CARD_SHOWN = "mywork_insight_card_shown",
    MYWORK_INSIGHT_CARD_CLICKED = "mywork_insight_card_clicked",
    MYWORK_INSIGHT_EVIDENCE_VIEWED = "mywork_insight_evidence_viewed",
    MYWORK_INSIGHT_EVIDENCE_LINK_CLICKED = "mywork_insight_evidence_link_clicked",
    MYWORK_INSIGHT_PROMPT_ACCORDION_CLICKED = "mywork_insight_prompt_accordion_clicked",
    MYWORK_INSIGHT_PROMPT_LINK_CLICKED = "mywork_insight_prompt_link_clicked",
    MYWORK_INSIGHT_CONVERSATION_STARTED = "mywork_insight_conversation_started",
    MYWORK_INSIGHT_CONVERSATION_FAILED = "mywork_insight_conversation_failed",
    MYWORK_PAGE_SHOWN = "mywork_page_shown",
    MYWORK_ACTIVATOR_CTA_CLICKED = "mywork_activator_cta_clicked",
    MYWORK_PERSPECTIVE_NUDGE_CARD_SHOWN = "mywork_perspective_nudge_card_shown",
    // Fired by MyWorkPage itself (not ProfileLinkSuggestionsCard) — the card emits a generic
    // create-profile-shown/create-profile-click past itself so each surface that reuses the card
    // can log its own contextual event name instead of a shared one.
    PROFILE_LINK_CREATE_PROFILE_PROMPT_SHOWN = "profile_link_create_profile_prompt_shown",
    PROFILE_LINK_CREATE_PROFILE_PROMPT_CLICKED = "profile_link_create_profile_prompt_clicked",
    PROFILE_LINK_SUGGESTION_CARD_SHOWN = "profile_link_suggestion_card_shown",
    PROFILE_LINK_SUGGESTION_SEE_ALL_CLICKED = "profile_link_suggestion_see_all_clicked",
    PROFILE_LINK_SUGGESTION_MODAL_SHOWN = "profile_link_suggestion_modal_shown",
    PROFILE_LINK_SUGGESTION_LINKED = "profile_link_suggestion_linked",
    PROFILE_LINK_SUGGESTION_SHARED = "profile_link_suggestion_shared",
    PROFILE_LINK_SUGGESTION_LINK_FAILED = "profile_link_suggestion_link_failed",
    PROFILE_LINK_SUGGESTION_REQUEST_FAILED = "profile_link_suggestion_request_failed",
    PROFILE_LINK_SUGGESTION_CELEBRATION_SHOWN = "profile_link_suggestion_celebration_shown",
    PROFILE_LINK_SUGGESTION_EXPLAINER_CLICKED = "profile_link_suggestion_explainer_clicked",
    PROFILE_LINK_SUGGESTION_LINK_ALL_CLICKED = "profile_link_suggestion_link_all_clicked",
    PROFILE_LINK_SUGGESTION_REMOVED = "profile_link_suggestion_removed",
    MIC_ERROR = "mic_error",
    MIC_INIT_SLOW = "mic_init_slow",
    MOMENTS_CARD_SHOWN = "moments_card_shown",
    COACHING_CONTEXT_CAROUSEL_SHOWN = "coaching_context_carousel_shown",
    COACHING_CONTEXT_CAROUSEL_DISMISSED = "coaching_context_carousel_dismissed",
    COACHING_CONTEXT_CAROUSEL_CTA_CLICKED = "coaching_context_carousel_cta_clicked",
    MS_TEAMS_CAROUSEL_DISMISSED = "ms_teams_carousel_dismissed",
    MS_TEAMS_CAROUSEL_OPENED_TEAMS = "ms_teams_carousel_opened_teams",
    RATER_ASSESSMENT_CARD_SHOWN = "rater_assessment_card_shown",
    RATER_ASSESSMENT_CARD_CTA_CLICKED = "rater_assessment_card_cta_clicked",
    REFLECTIONS_PROMO_CLICKED = "reflections_promo_clicked",
    // Nadia Assessments (Reflections).
    ASSESSMENT_HUB_VIEWED = "assessment_hub_viewed",
    ASSESSMENT_HUB_TAB_CHANGED = "assessment_hub_tab_changed",
    ASSESSMENT_START_VIEWED = "assessment_start_viewed",
    ASSESSMENT_CYCLE_CREATED = "assessment_cycle_created",
    ASSESSMENT_NOMINATE_VIEWED = "assessment_nominate_viewed",
    ASSESSMENT_RATER_ADDED = "assessment_rater_added",
    ASSESSMENT_RATER_INVITE_RESENT = "assessment_rater_invite_resent",
    ASSESSMENT_RATER_REMOVED = "assessment_rater_removed",
    ASSESSMENT_CYCLE_LAUNCHED = "assessment_cycle_launched",
    ASSESSMENT_CYCLE_DETAIL_VIEWED = "assessment_cycle_detail_viewed",
    ASSESSMENT_CYCLE_VIEW_RESULTS_CLICKED = "assessment_cycle_view_results_clicked",
    ASSESSMENT_SELF_ASSESS_VIEWED = "assessment_self_assess_viewed",
    ASSESSMENT_SELF_ASSESS_SUBMITTED = "assessment_self_assess_submitted",
    ASSESSMENT_RESULTS_VIEWED = "assessment_results_viewed",
    ASSESSMENT_RESULTS_PDF_DOWNLOAD_CLICKED = "assessment_results_pdf_download_clicked",
    ASSESSMENT_CAMPAIGN_PDF_DOWNLOAD_CLICKED = "assessment_campaign_pdf_download_clicked",
    ASSESSMENT_CAMPAIGN_CSV_DOWNLOAD_CLICKED = "assessment_campaign_csv_download_clicked",
    ASSESSMENT_RESULTS_CHAT_WITH_NADIA_CLICKED = "assessment_results_chat_with_nadia_clicked",
    ASSESSMENT_RESULTS_RETAKE_CLICKED = "assessment_results_retake_clicked",
    ASSESSMENT_RESULTS_VIEW_ALL_GOALS_CLICKED = "assessment_results_view_all_goals_clicked",
    ASSESSMENT_RATER_LANDING_VIEWED = "assessment_rater_landing_viewed",
    ASSESSMENT_RATER_BEGIN_CLICKED = "assessment_rater_begin_clicked",
    ASSESSMENT_RATER_DECLINED = "assessment_rater_declined",
    ASSESSMENT_RATER_RELATIONSHIP_VIEWED = "assessment_rater_relationship_viewed",
    ASSESSMENT_RATER_RELATIONSHIP_SUBMITTED = "assessment_rater_relationship_submitted",
    ASSESSMENT_RATER_SECTION_STARTED = "assessment_rater_section_started",
    ASSESSMENT_RATER_RESPONSE_SUBMITTED = "assessment_rater_response_submitted",
    ASSESSMENT_RATER_DONE_VIEWED = "assessment_rater_done_viewed",
    ASSESSMENT_RATER_DECLINED_VIEWED = "assessment_rater_declined_viewed",
    PERFORMANCE_REVIEW_CARD_CTA_CLICKED = "performance_review_card_cta_clicked",
    PERFORMANCE_REVIEW_CARD_CTA_COMPLETED_CLICKED = "performance_review_card_cta_completed_clicked",
    PERFORMANCE_REVIEW_TAB_CLICKED = "performance_review_tab_clicked",
    // Fired when the pre-conversation document-upload dialog is shown; the denominator for the
    // shown -> completed funnel (pairs with performance_review_pre_convo_upload_dialog_closed).
    PERFORMANCE_REVIEW_PRE_CONVO_UPLOAD_DIALOG_VIEWED = "performance_review_pre_convo_upload_dialog_viewed",
    // Fired at click-time on each internal entry point into the performance-management flow;
    // entry_source distinguishes homepage_card / side_nav / back_to_overview (external = utm_source).
    PERFORMANCE_REVIEW_ENTRY_CLICKED = "performance_review_entry_clicked",
    // Document-upload events for the pre-convo dialogs. Collapsed from runtime-built per-source names
    // (was: performance_review_{review_document,already_done}_{selected,upload_error,removed,submitted});
    // the originating dialog is now carried in the `dialog` property instead of the event name.
    // Note: the "uploaded" event is emitted server-side (link_documents endpoint), not here. See ENG-1224.
    PERFORMANCE_REVIEW_DOCUMENT_SELECTED = "performance_review_document_selected",
    PERFORMANCE_REVIEW_DOCUMENT_UPLOAD_FAILED = "performance_review_document_upload_failed",
    PERFORMANCE_REVIEW_DOCUMENT_REMOVED = "performance_review_document_removed",
    PERFORMANCE_REVIEW_DOCUMENT_SUBMITTED = "performance_review_document_submitted",
    PERFORMANCE_REVIEW_PICKER_VIEWED = "performance_review_picker_viewed",
    PERFORMANCE_REVIEW_PICKER_PHASE_SELECTED = "performance_review_picker_phase_selected",
    PERFORMANCE_REVIEW_PICKER_MOMENT_SELECTED = "performance_review_picker_moment_selected",
    PERFORMANCE_REVIEW_PICKER_GROUP_CLICKED = "performance_review_picker_group_clicked",
    PERFORMANCE_REVIEW_PICKER_ROW_CLICKED = "performance_review_picker_row_clicked",
    PERFORMANCE_REVIEW_PICKER_CLOSED = "performance_review_picker_closed",
    PERFORMANCE_REVIEW_PICKER_PAGE_LINK_CLICKED = "performance_review_picker_page_link_clicked",
    PERFORMANCE_REVIEW_RELATIONSHIP_CREATED = "performance_review_relationship_created",
    PERFORMANCE_REVIEW_TRACKER_VIEWED = "performance_review_tracker_viewed",
    PERFORMANCE_REVIEW_TRACKER_ROW_CLICKED = "performance_review_tracker_row_clicked",
    // Fired when the end-of-year performance moment page renders; review_count, sync_succeeded,
    // and the feature_flags snapshot make a silently-broken page visible in analytics.
    PERFORMANCE_REVIEW_MOMENT_VIEWED = "performance_review_moment_viewed",
    // Fired at click-time, before the conversation-create POST, so a launch that dies
    // (e.g. a stale CSRF token) still leaves a record that the user tried.
    PERFORMANCE_REVIEW_START_REVIEW_CTA_CLICKED = "performance_review_start_review_cta_clicked",
    CONNECTION_ADDED = "connection_added",
    PERSPECTIVE_ASSESSMENT_COMPLETED = "assessment_completed",
    PERSPECTIVE_ASSESSMENT_STARTED = "assessment_started",
    PERSPECTIVE_CARD_CLICKED = "perspective_card_clicked",
    PERSPECTIVE_CARD_SHOWN = "perspective_card_shown",
    PERSPECTIVE_OFFER_BANNER_CLICKED = "perspective_offer_banner_clicked",
    PERSPECTIVE_OFFER_BANNER_DISMISSED = "perspective_offer_banner_dismissed",
    PERSPECTIVE_OFFER_BANNER_SHOWN = "perspective_offer_banner_shown",
    PERSPECTIVE_TOPIC_CLICKED = "perspective_topic_clicked",
    PRIVATE_PROFILE_VIEWED = "private_profile_viewed",
    PRIVATE_PROFILE_TAB_CLICKED = "private_profile_tab_clicked",
    PRIVATE_PROFILE_INSIGHT_VIEWED = "private_profile_insight_viewed",
    PRIVATE_PROFILE_INSIGHT_CLICKED = "private_profile_insight_clicked",
    // COACHING JOURNEY EVENTS
    PROFILE_COMPLETION_CARD_SHOWN = "profile_completion_card_shown",
    PROFILE_COMPLETION_CARD_CLICKED = "profile_completion_card_clicked",
    COACHING_JOURNEY_ACCORDION_STEP_CLICKED = "coaching_journey_accordion_step_clicked",
    COACHING_JOURNEY_ACCORDION_SECTION_TOGGLED = "coaching_journey_accordion_section_toggled",
    COACHING_JOURNEY_ACCORDION_VIEWED = "coaching_journey_accordion_viewed",
    COACHING_JOURNEY_CALENDAR_CTA_CLICKED = "coaching_journey_calendar_cta_clicked",
    COLLABORATION_PROFILE_CREATION_VIEWED = "collaboration_profile_creation_viewed",
    COLLABORATION_PROFILE_CREATION_CLICKED = "collaboration_profile_creation_clicked",
    PUBLIC_PROFILE_UPLOAD_DOCUMENT_CLICKED = "public_profile_upload_document_clicked",
    PUBLIC_PROFILE_SKIP_DOCUMENT_UPLOAD = "public_profile_skip_document_upload",
    PUBLIC_PROFILE_DOCUMENT_REMOVED = "public_profile_document_removed",
    PUBLIC_PROFILE_DOCUMENT_UPLOADED = "public_profile_document_uploaded",
    PUBLIC_PROFILE_GENERATION_STARTED = "public_profile_generation_started",
    PUBLIC_PROFILE_PUBLISHED = "public_profile_published",
    PUBLIC_PROFILE_BASIC_INFO_SAVED = "public_profile_basic_info_saved",
    PUBLIC_PROFILE_SUBTOPIC_EDITED = "public_profile_subtopic_edited",
    PUBLIC_PROFILE_VISIBILITY_CHANGED = "public_profile_visibility_changed",
    PUBLIC_PROFILE_SEARCHED = "public_profile_searched",
    PUBLIC_PROFILE_SHARE_PROMPTED = "public_profile_share_prompted",
    PUBLIC_PROFILE_SHARED = "public_profile_shared",
    PUBLIC_PROFILE_VIEWED = "public_profile_viewed",
    PII_WARNING_BAR_SHOWN = "pii_warning_bar_shown",
    PII_WARNING_MODAL_SHOWN = "pii_warning_modal_shown",
    PII_BLOCKED_MODAL_SHOWN = "pii_blocked_modal_shown",
    PII_WARNING_MODAL_SEND_ANYWAY = "pii_warning_modal_send_anyway",
    PII_WARNING_EDITED = "pii_warning_edited",
    TURNED_ON_TEXT_INPUT = "turned_on_text_input",
    TURNED_ON_VOICE_INPUT = "turned_on_voice_input",
    UPLOAD_BUTTON_CLICKED = "upload_button_clicked",
    FEATURE_OF_THE_WEEK_CTA_CLICKED = "feature_of_the_week_cta_clicked",
    FEATURE_OF_THE_WEEK_DISMISSED = "feature_of_the_week_dismissed",
    UPLOAD_CANCELED = "upload_canceled",
    UPLOAD_FINISHED = "upload_finished",
    USER_MESSAGE_SENT = "user_message_sent",
    USER_RECORDING_ENDED = "user_recording_ended",
    USER_RECORDING_START = "user_recording_start",
    VOICE_NUDGE_DISMISSED = "voice_nudge_dismissed",
    VOICE_NUDGE_MIC_ACTIVATED = "voice_nudge_mic_activated",
    WRAPPED_ACTION_ITEMS_SHOWN = "wrapped_action_items_shown",
}

export default AmplitudeEventNames;
